import { JWTIFrameStylePropsType } from "@components/thirdParty/metabase/JWTIFrame/types";

export const APP_STYLES: JWTIFrameStylePropsType = {
  locale: "en-US",
  logo: false,
  top_nav: false,
  search: false,
  new_button: false,
  side_nav: false,
  header: false,
  additional_info: false,
  action_buttons: false,
};
